import { LoadableAfterPaint } from '@confluence/loadable';

export const PublishPageAsBlogDialog = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-PublishPageAsBlogDialog" */ '../src/PublishPageAsBlogDialog.tsx'
			)
		).PublishPageAsBlogDialog,
});
